<template>
  <div class="coupon-item" :class="couponItemClass" @click="clickTarget($event, coupon)">
    <div class="coupon-price-bg"></div>
    <div class="coupon-item-inner">
      <div class="left-price">
        <coupon-item-left :coupon="coupon"></coupon-item-left>
      </div>
      <div class="right-content">
        <div class="coupon-name" v-if="coupon.coupon_name">{{coupon.coupon_name}}</div>
        <div class="coupon-name" v-else>{{condition}}</div>
        <div class="coupon-desc">
          <span class="coupon-desc-text">{{ coupon.desc }}</span>
          <el-tooltip placement="top" popper-class="order-coupon-tooltip">
            <div slot="content" class="tips-content">
              <div class="product-list" v-if="coupon.product_name && coupon.product_name.length > 0">
                <div class="product-item" v-for="(v,index) in coupon.product_name" :key="index" >
                  <img class="icon" src="https://o.666visa.cn/static/ssqpeer/order/icon-star.png" alt="">
                  <div class="text">{{ v }}</div>
                </div>
              </div>
              <div class="coupon-explain-desc" v-else>{{coupon.desc}}</div>
            </div>
            <img
              class="tip-icon-question"
              v-if="(alwaysShow && coupon.scope) || coupon.scope === 2 || (showMore && coupon.scope && coupon.desc && coupon.desc.length > 9)"
              src="https://o.666visa.cn/static/ssqpeer/order/icon-query.png"
            >
          </el-tooltip>
        </div>
        <div class="coupon-duration">
          <div class="date-box">
            <template v-if="valid">
              <div class="time" v-if="getDays >=1 && coupon.start_date && coupon.end_date">{{coupon.start_date.replace(/-/g, '.')}}至{{coupon.end_date.replace(/-/g, '.')}}</div>
              <count-down v-else :haveBg="true"  :endTime="coupon.end_date"></count-down>
            </template>
            <template v-else>
              <span>{{ coupon.expiry_date }}</span> <span>{{ coupon.expiry_desc }}</span>
            </template>
          </div>

          <div class="expiry-tips" v-if="getDays <= 7 && getDays >1">
            <span>还剩{{Math.ceil(getDays)}}天</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import CouponItemLeft from '../../pages/user/user-children/components/coupon-item-left.vue';
import CountDown from '../count-down.vue';
import utils from '../../libs/utils';

export default {
  name: 'coupon-item',
  props: {
    valid: {
      type: Boolean,
      default: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    coupon: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    showMore: {
      type: Boolean,
      default: true,
    },
    alwaysShow: {
      type: Boolean,
      default: false,
    },
    couponIndex: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CouponItemLeft,
    CountDown,
  },
  data() {
    return {
      showUsage: false,
      urls: {
      },
    };
  },
  computed: {
    couponItemClass() {
      return {
        invalid: !this.valid,
        expired: this.coupon.expiry_desc === '已过期',
        used: this.coupon.expiry_desc === '已使用',
        selected: this.selected,
        selectable: this.selectable,
      };
    },

    expiryDiffDay() {
      const now = new Date();
      const today = new Date(`${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`).setHours(8);
      const expirdDate = new Date(this.coupon.end_date).getTime();
      const aDay = 24 * 60 * 60 * 1000;
      const diffDay = (expirdDate - today) / aDay;
      return diffDay;
    },
    getDays() {
      return utils.getDaysDifference(new Date(), this.coupon.end_date);
    },
    condition() {
      if (this.coupon && this.coupon.peer_coupon_type_id === 2) {
        return `满${this.coupon.reach_reduce_num}本可用`;
      } else if (this.coupon.reach_reduce) {
        return `满${this.coupon.reach_reduce / 100}元可用`;
      }
      return '无门槛';
    },
  },
  methods: {

    // 区分点击对象，执行不同操作
    clickTarget(event, coupon) {
      this.selectCoupon(coupon);
    },

    // 选择优惠券
    selectCoupon(coupon) {
      if (this.selectable) {
        this.$emit('couponExport', 'selectCoupon', coupon);
      }
    },

    // 显示优惠券说明弹窗
    couponExplain() {
      this.$emit('couponExport', 'couponExplain', {
        isShowCouponExplain: true,
        couponIndex: this.couponIndex,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.coupon-item {
  width: 342px;
  height: 92px;
  position: relative;
  z-index: 1;
  line-height: 1;
  .coupon-price-bg{
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;
    background: url(https://o.666visa.cn/static/ssqpeer/order/coupon-bg.png) no-repeat center / 100% 100%;
  }
  &.selected .coupon-price-bg{
    background: url(https://o.666visa.cn/static/ssqpeer/order/coupon-bg-active.png) no-repeat center / 100% 100%;
  }
  .coupon-item-inner{
    width: 100%;
    height: 100%;
    display: flex;
    .left-price{
      flex-shrink: 0;
      width: 97px;
      display: flex;
      align-items: center;
      justify-content: center;
      .price-content{
        display: flex;
        align-items: baseline;
        .price-sign{
          font-size: 15px;
          color: #fff;
          font-weight: 600;
        }
        .price-num{
          font-size: 34px;
          color: #fff;
          font-weight: 600;
        }
      }
    }
    .right-content{
      flex-grow: 1;
      overflow: hidden;
      padding: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .coupon-name{
        color: #2F333D;
        font-size: 14px;
      }
      .coupon-desc{
        margin-top: 10px;
        display: flex;
        align-items: center;
        .coupon-desc-text{
          color: #91999F;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .tip-icon-question{
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          cursor: pointer;
          margin-left: 6px;
        }

      }
      .coupon-duration{
        margin-top: 10px;
        color: #91999F;
        font-size: 12px;
        display: flex;
        align-items: center;
        .date-box{
          flex-shrink: 0;
        }
        .expiry-tips{
          background:linear-gradient(270deg,rgba(255,244,244,1) 0%,rgba(255,231,231,1) 100%);
          height: 18px;
          display: flex;
          align-items: center;
          padding: 0 4px;
          border-radius:9px;
          font-size: 12px;
          color: #FF6464;
          margin-left: 4px;
        }
      }
    }
  }

}
</style>
<style lang="less">
.order-coupon-tooltip{
  padding: 0;
  background: rgba(47,51,61,0.94) !important;
  border-radius: 2px;
  .popper__arrow{
    border-top-color: rgba(47,51,61,0.94) !important;
  }
  .tips-content{
    max-width: 300px;
    padding: 12px 12px;
    .product-list{
      .product-item{
        display: flex;
        align-items: flex-start;
        .icon{
          flex-shrink: 0;
          width: 8px;
          height: 8px;
          margin-top: 7px;
          margin-right: 6px;
        }
        .text{
          flex-grow: 1;
          overflow: hidden;
          color: #fff;
          font-size: 12px;
          line-height: 22px;
        }
      }
    }
    .coupon-explain-desc{
      color: #fff;
      font-size: 12px;
      line-height: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/order-coupon-item.vue